import axios from 'axios'

axios.defaults.headers.post["Content-Type"] = "application/json"

const axiosRIO = axios.create({
    baseURL: "https://raider.io/api/v1"
})

const axiosWL = axios.create({
    baseURL: ".netlify/functions/WarcraftLogs",
})

export {
    axiosRIO,
    axiosWL
}